import React, { useContext, useRef, useState } from "react";
import { store, ASSETS_URL } from './Store.js';
import { Link, useHistory } from "react-router-dom";
import useObtenerTraducciones from "../js/translations/useObtenerTraducciones.js";
import { Img } from "./shared/img.js";

/**
 * Componente de pie de página.
 * @returns {JSX.Element} El elemento del pie de página.
 */
const Footer = () => {
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const [country, setCountry] = useState(state.country || 'CO');
  const countries = [['CO', 'Colombia'], ['CL', 'Chile'], ['EC', 'Ecuador'], ['US', 'Estados Unidos'], ['MX', 'México']]
  const isLogged = state.sesionActiva !== null && state.sesionActiva === 'SI';
  const { datosHeader } = state;

  const inputCorreo = useRef()
  const formularioCorreo = useRef()
  const history = useHistory();

  const countryInfoSectionRef = useRef(null);

  const { isReady, textosSeccion: textosFooter } = useObtenerTraducciones('footer');
  const {producto_de, informacion_comercial, estados_unidos, boletin_descripcion, apoyo_de, derechos_reservados, terminos_condiciones, y, politica_privacidad, consulta, politica_soporte, placeholder, subscribirse } = textosFooter;

  const cambiarPais = ({ cod }) => {
    // dispatch({ type: 'CHANGE_VALUE', property: 'pais', value: cod })
  }

  return (
    <>
      {isLogged &&
        <div className="footer-inst pl-footer" style={{
          backgroundColor: datosHeader?.colorHeader,
          color: datosHeader?.colorLetra
        }}>
          <div className="row justify-content-center py-4 m-0">
            <div className="col-lg-5">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <Img alt="Logo institución" className="mx-auto d-block mm-brand img-fluid" id="logo-footer" src={`${ASSETS_URL}${datosHeader?.logo}`} />
                </div>
                <div className="col-lg-6 p-3 p-lg-3 inst-data">
                  {datosHeader?.telefono !== 'NULL' && <p id="instituto-telefono">{datosHeader?.telefono}</p>}
                  {datosHeader?.direccion !== 'NULL' && <p id="instituto-direccion">{datosHeader?.direccion}</p>}
                  {datosHeader?.correo !== 'NULL' && <p id="instituto-correo">{datosHeader?.correo}</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {isReady &&
        <footer tabIndex={0} aria-label="Footer" className="focusable-secondary pt-5 pt-lg-4 py-xl-2 px-3 px-xl-5">
          <div className="row mx-auto align-items-center justify-content-between">
            <div className="col-lg-4 col-md-6">
              <div className="row mx-0 align-items-center">
                <p className="col-md-4 footer-brand mx-auto">MakeMake</p>
                <div className="col-xl-5 col-md-8 px-1 d-flex flex-column justify-content-center align-items-center">
                  <p className="mt-3 mb-1 text-center">{producto_de || 'Es un producto de:'}</p>
                  <a className="focusable-secondary" aria-label="Makina Editorial, link." href="https://makinaeditorial.com/" target="_blank" rel="noopener noreferrer" >
                    <img className="" src="/img/logo-makina.png" alt="Logo de Makina Editorial"/>
                  </a>
                </div>
              </div>
              <ul 
                tabIndex={0} 
                aria-label="Botones de información de contacto para (Colombia, Chile, Ecuador, Estadous unidosy México)." className="mx-0 focusable-secondary mt-4 row footer-countries justify-content-between"
              >
                {
                  countries.map(item =>
                    <li key={item}>
                      <button tabIndex={0} key={` country${item}`} className={`focusable-secondary footer-country ${country === item[0] ? 'country-active' : ''}`} onClick={() => {
                        cambiarPais({ cod: item[0] })
                        setCountry(item[0])
                        countryInfoSectionRef.current.focus();
                      }}>{item[1]}</button>

                    </li>
                  )
                }
              </ul>
            </div>

            <div className="col-lg-4 col-md-6 py-4 py-xl-2 footer-data">
              <div className="focusable-secondary" tabIndex={0} role={"region"} ref = {countryInfoSectionRef} aria-label={'Información de contacto del país.'}>
                {
                  (() => {
                    switch (country) {
                      case 'CO':
                        return (
                          <div className="data-country" id="data-CO">
                            <p>{informacion_comercial || 'Para información comercial contactar a:'}</p>
                            <a className="focusable-secondary" href="mailto:catalina@makemake.com.co">
                              contacto@makemake.com.co
                            </a>
                            <p>(57) 350 236 7037</p>
                            <p>(57) 350 201 1041, (57) 313 450 9992</p>
                            <p>+1 (800) 345-5946 <em>ext 2241 </em> </p> 
                            <p>Cra 13 No. 33-74. Bogotá, Colombia</p>
                            
                          </div>
                        )
                      case 'CL':
                        return (
                          <div className="data-country" id="data-CL">
                            <p>{informacion_comercial || 'Para información comercial contactar a:'}</p>
                            <a className="focusable-secondary" href="mailto:rocio@pehuendigital.com">
                              rocio@pehuendigital.com
                            </a>
                            <p>(56 9) 94421606, (56 2) 27957133</p>
                            <p>Brown Norte 417, Ñuñoa. Santiago de Chile.</p>
                          </div>
                        )
                      case 'EC':
                        return (
                          <div className="data-country" id="data-EC">
                            <p>{informacion_comercial || 'Para información comercial contactar a:'}</p>
                            <a className="focusable-secondary" href="mailto:catalina@makemake.com.co">
                              contacto@makemake.com.co
                            </a>
                            <p>(57) 350 236 7037</p>
                            <p>(57) 350 201 1041, (57) 313 450 9992</p>
                            <p>Cra 13 No. 33-74. Bogotá, Colombia</p>
                          </div>
                        )
                      case 'US':
                        return (
                          <div className="data-country" id="data-US">
                            <p>{informacion_comercial || 'For commercial information, please contact:'}</p>
                            <p>{estados_unidos || 'Distribuidor en EE.UU, Canadá y Puerto Rico:'}<br /> Lectorum Publications Inc.</p>
                            <a className="focusable-secondary" href="mailto:acorrea@lectorum.com">
                              acorrea@lectorum.com
                            </a>
                            <p> + 1 (201) 559-2200 +1 (800) 345-5946</p>
                            <p>205 Chubb Avenue, Bldg A-1, Lyndhurst, NJ 07071</p>
                          </div>
                        )
                      case 'MX':
                        return (
                          <div className="data-country" id="data-MX">
                            <p>{informacion_comercial || 'Para información comercial contactar a:'}</p>
                            <a className="focusable-secondary" href="mailto:contacto@infoestrategica.com">
                              contacto@infoestrategica.com
                            </a>
                            <p>+52 55 90000210</p>
                            <p>Montecito 38, Piso 4 Oficina 22, Col. Nápoles, Benito Juárez, 03810 Ciudad de México, CDMX</p>
                          </div>
                        )
                      /* case 'CR':
                        return (
                          <div className="data-country" id="data-CR">
                            <p>{informacion_comercial || 'Para información comercial contactar a:'}</p>
                            <p>Estella Villalobos</p>
                            <a className="focusable-secondary" href="mailto:costa_rica@makemake.com.co">
                              costa_rica@makemake.com.co
                            </a>
                            <p>+506 8479 3478</p>
                            <p>Alajuela, Atenas, Costa Rica</p>
                          </div>
                        ) */
                      default:
                    }
                  })()
                }
              </div>
              <div>
                <ul className="row footer-icons justify-content-center justify-content-xl-start mt-3 mx-0">
                  <li>
                    <a className="focusable-secondary mr-3" aria-label="Facebook link" href="https://www.facebook.com/Bookmakemake/" target="_blank" rel="noopener noreferrer" >
                      <i className="fab fa-facebook-square fa-2x"></i>
                    </a>
                  </li>
                  <li>
                    <a className="focusable-secondary mr-3" aria-label="Instagram link" href="https://www.instagram.com/makemakelibros" target="_blank" rel="noopener noreferrer" >
                      <i className="fab fa-instagram fa-2x"></i>
                    </a>
                  </li>
                  <li>
                    <a className="focusable-secondary mr-3" aria-label="Youtube link" href="https://www.youtube.com/channel/UCAGRlTJB3fUDRfkVRPVNdzQ" target="_blank" rel="noopener noreferrer" >
                      <i className="fab fa-youtube fa-2x"></i>
                    </a>
                  </li>
                </ul>

              </div>

            </div>

            <div className="col-lg-4">
              <form ref={formularioCorreo}>
                <label className="text-center" htmlFor="newsletter-email">{boletin_descripcion || 'Suscríbete a nuestro boletín para recibir recomendaciones de lectura y actividades de nuestros libros.'}</label>
                <div className="row mx-0">
                  <input ref={inputCorreo} type="email" name="EMAIL" className="focusable-primary email col-lg-8 mb-1 mb-lg-2 footer-email" id="newsletter-email" placeholder={placeholder} required />
                  <div className="col-lg-4 mb-lg-2 px-0 px-lg-1">
                    <input
                      className="focusable-primary col-12 footer-subscribe button" id="newsletter-subscribe"
                      type="submit" value={subscribirse} name="subscribe"
                      onClick={(e) => {
                        if (formularioCorreo.current.checkValidity()) {
                          e.preventDefault()
                          history.push(`/boletin/ingresar-datos?email=${inputCorreo.current.value}`)
                        }
                      }}
                    />
                  </div>
                </div>
              </form>
            </div>

          </div>

          <div className="row mx-0 pt-4 align-items-center">
            <div className="col-lg-4 px-0">
              <div className="d-flex flex-column flex-md-row justify-content-center justify-content-lg-start align-items-center">
                <p className="text-center text-lg-left apoyo-text una-linea-texto">{apoyo_de || 'Con el apoyo de:'}</p>
                <a className="focusable-secondary icon-apoyo my-3 my-lg-0 ml-md-3"  aria-label="Inpulsa, link" href="https://www.innpulsacolombia.com/" target="_blank" rel="noopener noreferrer">
                  <img alt="Logo de Inpulsa" className="img-fluid" src="/img/apoyoDe/innpulsa-logo-header.svg" />
                </a>
                <a className="focusable-secondary icon-apoyo my-3 my-lg-0 mx-md-3" aria-label="Colombia productiva, link." href="https://www.colombiaproductiva.com/" target="_blank" rel="noopener noreferrer">
                  <img alt="Logo de Colombia productiva" className="img-fluid"  src="/img/apoyoDe/logo-colombia-productiva.svg" />
                </a>
                <a className="focusable-secondary icon-apoyo my-3 my-lg-0" aria-label="Economia naranja, link." href="https://economianaranja.gov.co/sello-colombia-crea/ " target="_blank" rel="noopener noreferrer">
                  <img alt="Logo de Economia naranja" className="img-fluid" src="/img/apoyoDe/logo-economia-naranja.png" />
                </a>
              </div>
            </div>
            <div className="col-lg-8 px-0 mb-5 mb-lg-0">

              <div className="footer-copyright px-3 px-md-0">
                <p>{derechos_reservados || 'Todos los derechos reservados. Consulta nuestros'} {""}
                  <Link className="focusable-secondary links-tyc" to="/terminos-y-condiciones" target="_blank">
                    {terminos_condiciones || 'Términos y condiciones'}
                  </Link>
                  {""} {y || 'y'} {""}
                  <Link className="focusable-secondary links-tyc" to="/politica-de-privacidad" target="_blank">
                    {politica_privacidad || 'Política de privacidad'}
                  </Link>
                  .
                  {consulta || 'Consulta nuestra'} {""}
                  <Link className="focusable-secondary links-tyc" to="/politica-de-soporte" target="_blank">
                   {politica_soporte || 'Política de soporte.'}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </footer>
      }

    </>
  )
}

export default Footer;